<template>
    <DashboardContainer>
        <campaigns/>
    </DashboardContainer>
</template>

<script>
import DashboardContainer from '../containers/DashboardContainer'
import campaigns from '../components/marketing/campaigns'

export default {
    name: 'emailCampaigns',
    beforeCreate: function () {
        var auth = this.$storage.get('auth')
        if (!auth) {
            this.$router.push('/login')
        }else{
            if(!auth.token){
                this.$router.push('/login')
            }
        }
    },
    components: {
        DashboardContainer,
        campaigns,
    }
}
</script>